import React, { useMemo, useRef, useState } from "react";
import { Link } from 'react-router-dom';
import logoElakay from './icon/logoelakayDiamant-256.png';
import DrawerToggleButton from '../../components/SIdeDrawer/DrawerToggleButton';
import ExpandingSearch from "./ExpandingSearch/ExpandingSearch";
import { GrUpdate } from "react-icons/gr";
import './headerShopSeller.css';
import { elakayAutoText, getElakayLanguageContext } from "../pageInside/dataElakay";
import { Family } from "../pageInside/Rolle";
import ShareButton from "../pageInside/ShareButton";
import { getDefaultTitleStyle } from "../../utils/titleStyle";
import { useHeaderHeightVar } from "./useHeaderHeightVar";
import { FaMapMarkerAlt } from "react-icons/fa";
import { isAuthenticated } from "../auth";
import LocalSellingModal from "../pageInside/LocalSellingModal";
import { ShopManagementMenuItems, useShopHeaderNavigation } from "./ShopHeaderManagement";
import { formatLakayShopTitle, separateLakayWord } from "../../utils/lakayShopName";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["headerShopSeller"]?.[key] || fallback;

export const SHOP_HEADER_STYLE_DEFAULTS = {
  backgroundColor: "Snow",
  shadowColor: "rgba(0, 0, 0, 0.1)",
  borderColor: "#ece9f5",
  height: "85px",

  shopNameColor: "#111111",
  shopNameFontFamily: "inherit",
  shopNameFontSize: "1.5rem",
  shopNameFontWeight: 700,

  menuColor: "#000000",
  menuFontFamily: "inherit",
  menuFontSize: "16px",
  menuFontWeight: 600,

  searchBackgroundColor: "#ffffff",
  searchTextColor: "#000000",
  searchPlaceholderColor: "#9ca3af",
  searchBorderColor: "#cccccc",
  searchFontFamily: "inherit",
  searchFontSize: "16px",

  modeBarBackground: "rgba(255,255,255,0.95)",
  modeBarBorderColor: "#ece9f5",
  modeActiveColor: "#6d28d9",
  modeInactiveColor: "#000000",
  modeActiveBackground: "#f5f3ff",
  modeActiveBorderColor: "#c4b5fd",

  editorChipBackground: "linear-gradient(135deg,#6d28d9,#8b5cf6)",
  editorChipColor: "#ffffff",
};

function buildShopHeaderTheme(infoSource, explicitSettings) {
  const raw = explicitSettings || infoSource?.allSettings?.headerShopSeller || {};
  const baseHeader = infoSource?.allSettings?.header || {};
  // Fallback intermédiaire : AnimationSettings → General → "Default Title
  // Styles", entre les réglages dédiés du header shop (raw.*, priorité) et
  // les défauts codés en dur (SHOP_HEADER_STYLE_DEFAULTS, dernier recours).
  const titlePresentation = getDefaultTitleStyle(infoSource?.allSettings?.defaultTitleStyle);

  return {
    ...SHOP_HEADER_STYLE_DEFAULTS,

    backgroundColor: raw.backgroundColor || raw.navbarBackgroundColor || SHOP_HEADER_STYLE_DEFAULTS.backgroundColor,
    shadowColor: raw.shadowColor || raw.navbarShadowColor || SHOP_HEADER_STYLE_DEFAULTS.shadowColor,
    borderColor: raw.borderColor || raw.navbarBorderColor || SHOP_HEADER_STYLE_DEFAULTS.borderColor,
    height: raw.height || SHOP_HEADER_STYLE_DEFAULTS.height,

    shopNameColor: raw.shopNameColor || raw.titleColor || raw.textColor || titlePresentation.style.color || SHOP_HEADER_STYLE_DEFAULTS.shopNameColor,
    shopNameFontFamily: raw.shopNameFontFamily || raw.titleFontFamily || titlePresentation.style.fontFamily || SHOP_HEADER_STYLE_DEFAULTS.shopNameFontFamily,
    shopNameFontSize: raw.shopNameFontSize || raw.titleFontSize || raw.fontSize || titlePresentation.style.fontSize || SHOP_HEADER_STYLE_DEFAULTS.shopNameFontSize,
    shopNameFontWeight: raw.shopNameFontWeight || raw.titleFontWeight || titlePresentation.style.fontWeight || SHOP_HEADER_STYLE_DEFAULTS.shopNameFontWeight,

    menuColor: raw.menuColor || raw.linkColor || SHOP_HEADER_STYLE_DEFAULTS.menuColor,
    menuFontFamily: raw.menuFontFamily || raw.linkFontFamily || SHOP_HEADER_STYLE_DEFAULTS.menuFontFamily,
    menuFontSize: raw.menuFontSize || raw.linkFontSize || SHOP_HEADER_STYLE_DEFAULTS.menuFontSize,
    menuFontWeight: raw.menuFontWeight || raw.linkFontWeight || SHOP_HEADER_STYLE_DEFAULTS.menuFontWeight,

    searchBackgroundColor: raw.searchBackgroundColor || baseHeader.searchBackgroundColor || SHOP_HEADER_STYLE_DEFAULTS.searchBackgroundColor,
    searchTextColor: raw.searchTextColor || SHOP_HEADER_STYLE_DEFAULTS.searchTextColor,
    searchPlaceholderColor: raw.searchPlaceholderColor || SHOP_HEADER_STYLE_DEFAULTS.searchPlaceholderColor,
    searchBorderColor: raw.searchBorderColor || SHOP_HEADER_STYLE_DEFAULTS.searchBorderColor,
    searchFontFamily: raw.searchFontFamily || SHOP_HEADER_STYLE_DEFAULTS.searchFontFamily,
    searchFontSize: raw.searchFontSize || SHOP_HEADER_STYLE_DEFAULTS.searchFontSize,

    modeBarBackground: raw.modeBarBackground || SHOP_HEADER_STYLE_DEFAULTS.modeBarBackground,
    modeBarBorderColor: raw.modeBarBorderColor || SHOP_HEADER_STYLE_DEFAULTS.modeBarBorderColor,
    modeActiveColor: raw.modeActiveColor || SHOP_HEADER_STYLE_DEFAULTS.modeActiveColor,
    modeInactiveColor: raw.modeInactiveColor || SHOP_HEADER_STYLE_DEFAULTS.modeInactiveColor,
    modeActiveBackground: raw.modeActiveBackground || SHOP_HEADER_STYLE_DEFAULTS.modeActiveBackground,
    modeActiveBorderColor: raw.modeActiveBorderColor || SHOP_HEADER_STYLE_DEFAULTS.modeActiveBorderColor,

    editorChipBackground: raw.editorChipBackground || SHOP_HEADER_STYLE_DEFAULTS.editorChipBackground,
    editorChipColor: raw.editorChipColor || SHOP_HEADER_STYLE_DEFAULTS.editorChipColor,
  };
}

const HeaderShopSeller = (props) => {
  const navRef = useRef(null);
  useHeaderHeightVar(navRef);

  const [mobileSearchExpanded, setMobileSearchExpanded] = useState(false);
  const [showLocalSelling, setShowLocalSelling] = useState(false);
  const { token } = isAuthenticated() || {};
  const {
    infoSource,
    userID,
    shopName = "Seller",
    loadindSearCh,
    onFilterShop,
    search,
    drawerClickHander,
    myShop = false,
    lakaySeller = false,
    showFilter = true,
    outOffPage,
    setActiveHeader,
    pageShop = "boutique",
    setPageShop = () => {},
    setShowShopPicker = null,
    shopHeaderSettings,
    // Shared shop header (Seller shop by default). A shop of another kind (Provider storefront)
    // passes its OWN paths/links; nothing below changes for the Seller shop when they are omitted.
    shopPath,
    aboutPath,
    shareUrl,
    titleText,
    searchPlaceholder,
    onRefresh,
    menuStartItems = null,
    menuEndItems = null,
    activeSection = null,
    // Shop WEBSITE mode ("seller" | "provider"; omitted = historic header, e.g. Page Builder element):
    // adds the management group (Dashboard | Dropshipping In | My Products) for a viewer allowed to
    // manage this shop (`canManageShop`, decided by the page from the shop's owner), and -- when the
    // header carries the ☰ button -- registers the shop navigation for the ☰ drawer (small screens
    // keep Home / Search / ☰ only). `drawerTitle` / `drawerShopItems`: extra drawer data (custom pages).
    shopType = null,
    canManageShop = false,
    drawerTitle,
    drawerShopItems = null,
    // Next to the shop name (My Shop Customer View: "My Shops" + "Create New Shop").
    titleExtra = null,
  } = props;
  const homeTo = shopPath || `/lakay-ShopSeller/${userID}`;
  // "/about" goes before the query (?shop=<boutique>), never after it.
  const [homePathname, homeQuery = ""] = homeTo.split("?");
  const aboutTo = aboutPath || `${homePathname}/about${homeQuery ? `?${homeQuery}` : ""}`;

  __setElakayInfoSource(infoSource);
  const { userInfo } = infoSource;

  // Shop website mode: management links (owner only) + ☰ drawer registration (ShopHeaderManagement.jsx).
  const labels = infoSource?.laguangeElakay?.('title', infoSource.languageAPI) || {};
  const { management, managementLabel, history, siteMode } = useShopHeaderNavigation({
    shopType, infoSource, canManageShop, outOffPage, showFilter, onFilterShop,
    title: drawerTitle || titleText || shopName, homeTo, aboutTo, extraShopItems: drawerShopItems,
    labels: { home: labels.home, about: labels.aboutUs, filter: labels.filter },
  });

  const theme = useMemo(
    () => buildShopHeaderTheme(infoSource, shopHeaderSettings),
    [infoSource, shopHeaderSettings]
  );

  const navbarStyle = {
    "--headershop-background": theme.backgroundColor,
    "--headershop-shadow": theme.shadowColor,
    "--headershop-border": theme.borderColor,
    "--headershop-height": "85px",
    "--headershop-title-color": theme.shopNameColor,
    "--headershop-title-font": theme.shopNameFontFamily,
    "--headershop-title-size": theme.shopNameFontSize,
    "--headershop-title-weight": theme.shopNameFontWeight,
    "--headershop-menu-color": theme.menuColor,
    "--headershop-menu-font": theme.menuFontFamily,
    "--headershop-menu-size": theme.menuFontSize,
    "--headershop-menu-weight": theme.menuFontWeight,
    "--headershop-mode-background": theme.modeBarBackground,
    "--headershop-mode-border": theme.modeBarBorderColor,
  };

  const handleChange = (event) => {
    const val = event.target.value;
    if (typeof loadindSearCh !== "function") return;
    if (val?.length === 0) {
      loadindSearCh('');
    } else {
      loadindSearCh(val);
    }
  };

  return (
    <nav
      ref={navRef}
      className={`headershop-navbar ${myShop ? "headershop-navbar-with-modes" : ""}${siteMode ? " headershop-navbar--site" : ""}`}
      data-shop-type={shopType || undefined}
      style={navbarStyle}
    >
      <div className="headershop-top-row">
        <div className="headershop-title-wrapper">
          <Link
            to={homeTo}
            className="autoWidthHeaderShopSeller"
            title={titleText ? separateLakayWord(titleText) : undefined}
          >
            {titleText ? separateLakayWord(titleText) : formatLakayShopTitle(shopName, __elakayText("t002", "Lakay"))}
          </Link>
        </div>
        {titleExtra && <div className="headershop-title-extra">{titleExtra}</div>}

        <ShareButton
          infoSource={infoSource}
          url={shareUrl || (typeof window !== "undefined" ? `${window.location.origin}${homeTo}` : undefined)}
          title={shopName}
          className="headershop-share"
        />

        <div
        className={`headershop-search-container ${mobileSearchExpanded ? "search-open" : ""}`}
        >
          <ExpandingSearch
            infoSource={infoSource}
            handleChange={handleChange}
            setIsFocused={() => {}}
            search={search}
            collapseOnMobile
            expanded={mobileSearchExpanded}
            setExpanded={setMobileSearchExpanded}
            wrapperStyle={{
              border: `2px solid ${theme.searchBorderColor}`,
              background: theme.searchBackgroundColor,
              "--exp-icon-color": theme.menuColor,
              "--exp-icon-border": theme.searchBorderColor,
            }}
            inputStyle={{
              color: theme.searchTextColor,
              fontFamily: theme.searchFontFamily,
              fontSize: theme.searchFontSize,
              background: "transparent",
            }}
            placeholderColor={theme.searchPlaceholderColor}
            placeholder={searchPlaceholder}
          />
        </div>
      </div>

      <div className="headershop-bottom-row">
        <ul className="headershop-menu">
          {!outOffPage && <>
            <li className="headershop-menu-item headershop-drawer-item" onClick={drawerClickHander}>
              <DrawerToggleButton classToggle={"toggle-button_line1"} variant="dark" />
            </li>
            <li className="headershop-menu-item headershop-update-icon" onClick={() => (onRefresh ? onRefresh() : setActiveHeader?.(1))}>
              <GrUpdate />
            </li>
            <li className="headershop-menu-item headershop-menu-item--elakay">
              <Link to={`/`} className="headershop-menu-link">
                <img className="img-responsive" src={logoElakay} width="14" alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).headerShopSeller.t001} />
                {__elakayText("t003", "elakay")}
              </Link>
            </li>
          </>}

          {lakaySeller && <>
            <li className="headershop-menu-item">
              <Link to="#" className="headershop-menu-link">
                {infoSource.laguangeElakay('homePage', infoSource.languageAPI).bestSellers}
              </Link>
            </li>
            <li className="headershop-menu-item">
              <Link to="#" className="headershop-menu-link">
                {infoSource.laguangeElakay('headNenu', infoSource.languageAPI).todayDeal}
              </Link>
            </li>
          </>}

          {menuStartItems}

          <li className="headershop-menu-item">
            <Link to={homeTo} className="headershop-menu-link" aria-current={activeSection === "home" ? "page" : undefined}>
              {infoSource.laguangeElakay('title', infoSource.languageAPI).home}
            </Link>
          </li>
          <li className="headershop-menu-item headershop-menu-item--about">
            <Link to={aboutTo} className="headershop-menu-link" aria-current={activeSection === "about" ? "page" : undefined}>
              {infoSource.laguangeElakay('title', infoSource.languageAPI).aboutUs}
            </Link>
          </li>

          {showFilter && (
            <li className="headershop-menu-item headershop-menu-item--filter">
              <button type="button" onClick={onFilterShop} className="headershop-menu-link headershop-menu-button">
                {infoSource.laguangeElakay('title', infoSource.languageAPI).filter}
              </button>
            </li>
          )}

          {menuEndItems}

          <ShopManagementMenuItems items={management} label={managementLabel} history={history} />

          {myShop && typeof setShowShopPicker === "function" && (
            <li className="headershop-menu-item">
              <button type="button"
              onClick={() => setShowShopPicker(true)}
              className="headershop-menu-link headershop-store-picker-button"
              style={{
                background: theme.editorChipBackground,
                color: theme.editorChipColor,
              }}
            >
              <span className="headershop-store-picker-icon">🏪</span><span>{__elakayText("t004", "Choisir une boutique")}</span><span aria-hidden="true">›</span>
              </button>
            </li>
          )}
          {myShop && Family(userInfo?.email) && (
              <li className="headershop-menu-item">
                <Link to="/pageBuilder?mode=store" className="headershop-menu-link">
                {elakayAutoText("h_0e15b55d222eaf", "🎨 Page & Content")}
                </Link>
              </li>
          )}
          {myShop && (
              <li className="headershop-menu-item">
                {/* Shortcut to the exact same LocalSellingModal used from User
                    Settings -- same component, same state, same endpoint
                    (mission 2.2). Never a second/forked form. */}
                <button type="button" onClick={() => setShowLocalSelling(true)} className="headershop-menu-link headershop-menu-button">
                  <FaMapMarkerAlt /> {infoSource.laguangeElakay('localSelling', infoSource.languageAPI)?.modalTitle || elakayAutoText("h_9c7e3a1b2d4f56", "Target Location")}
                </button>
              </li>
          )}
        </ul>

        {myShop && (
          <div className="headershop-mode-bar">
            {[
              { key: "boutique", icon: "🏪", label: elakayAutoText("h_05236d3a83691d", "Boutique") },
              { key: "builder", icon: "🎨", label: elakayAutoText("h_4759bf14d7a511", "Builder") },
              { key: "preview", icon: "👁", label: elakayAutoText("h_e47a5cf99b95d2", "Apercu") },
              { key: "helps",   icon: "❓", label: elakayAutoText("h_c47ae15370cfe1", "Help") },
            ].map(({ key, icon, label }) => (
              <button
                key={key}
                onClick={() => setPageShop(key)}
                className={`headershop-mode-button ${pageShop === key ? "active" : ""}`}
                style={{
                  color: pageShop === key ? theme.modeActiveColor : theme.modeInactiveColor,
                  background: pageShop === key ? theme.modeActiveBackground : "transparent",
                  border: `1px solid ${pageShop === key ? theme.modeActiveBorderColor : "transparent"}`,
                }}
              >
                {icon} {label}
              </button>
            ))}
          </div>
        )}
      </div>

      {myShop && (
        <LocalSellingModal
          showModal={showLocalSelling}
          setShowModal={setShowLocalSelling}
          infoSource={infoSource}
          token={token}
        />
      )}
    </nav>
  );
};

export default HeaderShopSeller;
